<template>
    <div>
        <b-container fluid class="px-0 portfolio-slider" :style="{ backgroundColor: styles.bgColor }" >
            <b-row>
                <b-col lg="6" 
                class="px-0" 
                :class="{ 
                    'order-2' : !styles.imgOnLeftSide,
                    'order-1' : styles.imgOnLeftSide 
                    }">
                    <client-only>
                        <slick
                        ref="imgSlider"
                        :options="imgSliderOptions"
                        class="slick-for img-slider"
                        style="margin-bottom: -6px"
                        >
                            <div 
                            v-for="(slide, i) in slides" 
                            class="" 
                            :key="i"
                            >
                                <img 
                                    :src="slide.img"
                                    class="w-100 h-auto d-block"
                                    :alt="slide.alt"
                                >
                                <b-row class="mx-0">
                                    <b-col cols="6" class="px-0 d-flex h-100">
                                        <img 
                                            :src="slide.imgLeft"
                                            class="w-100 h-100 d-block"
                                            :alt="slide.alt"
                                        >
                                    </b-col>
                                    <b-col cols="6" class="px-0 d-flex h-100">
                                        <img 
                                            :src="slide.imgRight"
                                            class="w-100 h-100 d-block"
                                            :alt="slide.alt"
                                        >
                                    </b-col>
                                </b-row>
                            </div>
                        </slick>
                    </client-only>
                </b-col>
                <b-col lg="6" 
                class="px-0"
                :class="{ 
                    'order-2' : styles.imgOnLeftSide, 
                    'order-1' : !styles.imgOnLeftSide 
                }">
                    <div class="px-5 py-5 d-lg-flex justify-content-center flex-column h-100 w-100 max-w-480 mx-auto"
                    :style="{color: styles.textColor}">

                        <div 
                            class="slick-copy">
                            <p class="gotham-bold">
                                {{ styles.heading }}
                            </p>
                            <p class="gotham-book">
                                {{ styles.desc }}
                            </p>
                            <p class="gotham-bold">
                                {{ styles.subheading }}
                            </p>
                            <div class="slider-dots-column-slider" :class="[styles.sliderClass]"></div>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
export default {
    props: ['slides', 'styles'],
    data() {
        return {
            imgSliderOptions: {
                fade: true,
                slidesToShow: 1,
                arrows: false,
                dots: true,
                infinite: false,
                vertical: false,
                lazyLoad: 'ondemand',
                verticalSwiping: false,
                asNavFor: null,
                autoplay: false,
                centerMode: false,
                autoplaySpeed: 6500,
                adaptiveHeight: false,
                appendDots: null,
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            dots: true,
                            arrows: true,
                        }
                    }
                ]
            }
        }
    },
    beforeMount() {
        this.imgSliderOptions.appendDots = '.slider-dots-column-slider'
    },
    methods: {

    },
    mounted() {
        
    }
}
</script>

<style lang="scss" >

.text-slider {
    .slick-list {
        
    }
}

.portfolio-slider {
    .slick-dotted.slick-slider {
        margin-bottom: -6px;
    }   
    .slider-dots-column-slider {
        .slick-dots {
            position: relative;
            bottom: 0;
            // left: 93px;
            // display: inline-block;
            width: auto;
            padding: 0;
            margin: 30px 0 0;
            list-style: none;
            text-align: left;

            @media screen and (max-width: 823px) {
                left: 50%;
                transform: translateX(-50%);
            }

            li.slick-active {

                button {

                    &::before {
                        font-family: 'slick';
                        font-size: 6px;
                        line-height: 20px;
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 80px;
                        height: 4px;
                        content: '';
                        text-align: center;
                        opacity: 1;
                        color: black;
                        -webkit-font-smoothing: antialiased;
                        -moz-osx-font-smoothing: grayscale;
                        background-color: #fff;
                        border: 1px solid #fff;
                    }
                }
            }

            li {
                width: 80px;

                button {
                    &::before {
                        font-family: 'slick';
                        font-size: 6px;
                        line-height: 20px;
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 80px;
                        height: 4px;
                        content: '';
                        text-align: center;
                        opacity: .25;
                        color: black;
                        -webkit-font-smoothing: antialiased;
                        -moz-osx-font-smoothing: grayscale;
                        background-color: #fff;
                        border: 1px solid #fff;
                    }
                }
            }
        }
    };
    .slider-dots-column-slider-black {
        .slick-dots {
            li.slick-active {
                button {
                    &::before {
                        color: black !important;
                        background-color: #000 !important;
                        border: 1px solid #000 !important;
                    }
                }
            }

            li {
                button {
                    &::before {
                        color: black !important;
                        background-color: #000 !important;
                        border: 1px solid #000 !important;
                    }
                }
            }
        }
    }
}

</style>